import styled from 'styled-components'

import { FormattedSlot } from '@/apiTypes.ts'
import ContactSvg from '@/assets/svgs/contact.svg'
import LocationSvg from '@/assets/svgs/location.svg'
import { DoctorImage, DoctorInitials } from '@/components/Doctor.tsx'
import { Text } from '@/components/Text.tsx'

const Appointment = styled.div`
  display: flex;
  flex-flow: column;
  text-align: left;
`

const AppointmentCol = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  padding: 13px 0 16px 0;
  border-bottom: 1px solid rgba(34, 34, 34, 0.1);

  &:last-child {
    border-bottom: none;
  }
`

const AppointmentImg = styled.div`
  position: relative;
  top: 3px;
  flex: 0 0 60px;
`

const AppointmentDetail = styled.div`
  display: flex;
  flex-flow: column;
`

const AppointmentDetailHeading = styled(Text)`
  color: #222222;
  font-weight: 500;
`

const Confirm = ({ slot }: { slot: FormattedSlot }) => {
  return (
    <Appointment>
      <AppointmentCol>
        <AppointmentImg>
          <img src={ContactSvg} />
        </AppointmentImg>
        <AppointmentDetail>
          <AppointmentDetailHeading data-testid="appointmentType">
            {slot.name || slot.description}
          </AppointmentDetailHeading>
          <Text>{slot.durationInMinutes} min</Text>
        </AppointmentDetail>
      </AppointmentCol>

      <AppointmentCol>
        <AppointmentImg>
          <img src={LocationSvg} />
        </AppointmentImg>
        <AppointmentDetail>
          <AppointmentDetailHeading data-testid="location">
            {slot.location.name || slot.location.fullName}
          </AppointmentDetailHeading>
          <Text>{slot.location.address}</Text>
        </AppointmentDetail>
      </AppointmentCol>

      <AppointmentCol>
        <AppointmentImg>
          {slot.practitioner.picture ? (
            <DoctorImage
              src={slot.practitioner.picture}
              alt={slot.practitioner.name}
            />
          ) : (
            <DoctorInitials name={slot.practitioner.name} />
          )}
        </AppointmentImg>
        <AppointmentDetail>
          <AppointmentDetailHeading data-testid="doctor">
            {slot.practitioner.name}
          </AppointmentDetailHeading>
          <Text data-testid="dateTime">
            {slot.start.format('dddd, DD/MM/YYYY - HH:mm')}
          </Text>
        </AppointmentDetail>
      </AppointmentCol>
    </Appointment>
  )
}

export { Confirm }
